import React from 'react';

class IndexPage extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    componentDidMount() {
    }


    render() {
        return (
            <div>

            </div>
        );
    }

}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/page/jsx/IndexPage.jsx